import { render } from "./InternalNav.vue?vue&type=template&id=16d4fc10"
import script from "./InternalNav.vue?vue&type=script&lang=js"
export * from "./InternalNav.vue?vue&type=script&lang=js"
script.render = render

export default script